var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "bg-education text-white py-2 px-4 text-center d-flex align-items-center justify-content-between gap-75",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "d-inline-flex justify-content-center align-items-center gap-75 flex-wrap",
        },
        [
          _c("i", { staticClass: "far fa-graduation-cap font-size-200" }),
          _vm._v(" "),
          _c("span", { domProps: { innerHTML: _vm._s(_vm.description) } }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "gap-75 d-inline-flex align-items-center justify-content-center flex-wrap",
            },
            [
              _c("ButtonWithLoadingState", {
                staticClass: "btn btn-warning font-weight-bold",
                attrs: {
                  text: _vm.buttonText,
                  "is-state-loading": _vm.stateLoading,
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.requestEducationConfirmationMail.apply(
                      null,
                      arguments
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "text-white text-underline",
                  attrs: { href: _vm.linkEducation },
                },
                [_vm._v(_vm._s(_vm._f("trans")("Learn more")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("span", {
        staticClass:
          "pull-right font-size-200 cursor-pointer notification-close",
        on: {
          click: function ($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.dismiss.apply(null, arguments)
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }